import axios from 'axios';
import { isRecord } from '../../../@interfaces/site-analytics/validation';
// 閲覧対象外は各解析画面が非表示／利用不可として扱うため、共通アラートを重ねない。
export const isExpectedAnalyticsUnavailableError = (error) => {
    var _a, _b, _c;
    return axios.isAxiosError(error) &&
        ((_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a.method) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'get' &&
        ((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 403 &&
        isRecord(error.response.data) &&
        ['ANALYTICS_UNAVAILABLE', 'SEARCH_CONSOLE_UNAVAILABLE'].includes(String(error.response.data.code));
};
